import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://via.placeholder.com/40x40.png?text=back",
  alt: "back"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Create products", -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12" }
const _hoisted_5 = {
  key: 0,
  class: "text-danger validation-summary-errors",
  "data-valmsg-summary": "true"
}
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 control-label" }, "Barcode", -1)
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 control-label" }, "Name", -1)
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 control-label" }, "Description", -1)
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-2 control-label" }, "Category", -1)
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_RouterLink, { to: { name: 'home' } }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.errorMsg != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, _toDisplayString(_ctx.errorMsg), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "col-sm-2",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.barcode) = $event))
          }, null, 512), [
            [_vModelText, _ctx.barcode]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "col-sm-2",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event))
          }, null, 512), [
            [_vModelText, _ctx.name]
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "col-sm-2",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.description) = $event))
          }, null, 512), [
            [_vModelText, _ctx.description]
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _withDirectives(_createElementVNode("select", {
            class: "col-sm-2",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.categoryId) = $event))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCategoryList(), (option) => {
              return (_openBlock(), _createElementBlock("option", {
                key: option.id,
                value: option.id
              }, _toDisplayString(option.name), 9, _hoisted_14))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.categoryId]
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("input", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.submitClicked())),
              type: "submit",
              value: "Create",
              class: "btn btn-primary"
            })
          ])
        ])
      ])
    ])
  ], 64))
}